import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import EmailSignatureService from "../../services/EmailSignatureService";
import { DOCGUI } from "../../constants/GeneralConstants";
import { ArrowIcon } from "../SvgComponents/ArrowIcon/ArrowIcon";

export const SSIModal = ({
  openSSIModal,
  signerGuid,
  docGuid,
  provider,
}) => {
  const { t } = useTranslation();

  const handleContinueSSI = () => {
    localStorage.setItem(DOCGUI, docGuid);
    EmailSignatureService.getSSIUrl(signerGuid)
      .then((response) => {
        const { Url } = response.data;
        
        window.location.href = Url;
      });
  }

  return (
    <Modal
      title=""
      style={{ top: 150 }}
      footer={null}
      open={openSSIModal}
      closable={false}
    >
      <div className="modal-container">
        <strong><p>{t("sign.auth_provider_title", { provider })}</p></strong>
        <p className="nu-input-label">{t("sign.auth_provider_description", { provider })}</p>

        <Col className="action-buttons mobile-button">
          <Row>
            <Col md={12} xs={12} lg={12}>
              <button
                type="button"
                className="btn btn-primary btn-active"
                onClick={handleContinueSSI}
              >
                <span className="cancel-text">{t("general.continue")}</span>
                <ArrowIcon />
              </button>
            </Col>
          </Row>
        </Col>
      </div>
    </Modal>
  );
};
